<template>
  <div class="w-full h-full relative">
    <div class="px-11">
      <div class="font-normal mb-4">
        <div class="flex justify-center items-center flex-col">
          <div class="mt-3">
            <megaphone-icon />
          </div>
          <p class="text-2xl mt-5 text-fg-default font-extrabold mb-5">
            Coming Soon!!!
          </p>
          <p
            style="word-break: normal"
            class="text-sm text-root-12 text-center font-normal"
          >
            We love to see you here and our team can't wait to bring you this
            fantastic feature, which you would love. For more information about
            the release date, keep an eye on your emails and notification lists.
          </p>
          <div class="mt-8 w-full">
            <!-- <div
              v-if="!isNotified"
              @click="getNotified"
              class="w-full flex justify-center items-center bg-primary py-4 text-white rounded-lg cursor-pointer"
            >
              <div v-if="isLoading">
                <loading-animation class="circle-pulse" />
              </div>
              <p v-else class="text-13px">Get notified</p>
            </div> -->
            <!-- <div
              class="w-full flex justify-center items-center bg-blue-60 py-4 text-primary rounded-lg text-13px"
            >
              We would notify you when its live
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: false,
      isNotified: false
    }
  },
  methods: {
    getNotified () {
      this.isLoading = true
      this.isLoading = false
      this.isNotified = true
    }
  },
  components: {
    MegaphoneIcon: () => import('@/assets/v2/icons/MegaphoneIcon.vue')
    // LoadingAnimation: () => import('@/assets/v2/icons/LoadingAnimation.vue')
  }
}
</script>

<style scoped>
.circle-pulse {
  animation: pulse 2s cubic-bezier(0.5, 0, 0.8, 1) infinite;
}
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}
>>> .el-input--prefix .el-input__inner {
  border: 1px solid var(--border-1);
  border-radius: 8px;
  background: var(--background-10);
}
.blue-background {
  background: rgba(208, 227, 252, 0.2);
}
</style>
